import { Button, 
    Drawer, 
    DrawerBody, 
    DrawerCloseButton, 
    DrawerContent, 
    DrawerFooter, 
    DrawerHeader, 
    DrawerOverlay, 
    useDisclosure } from "@chakra-ui/react";
  import React from "react";
  import UserForm from "./UserForm";
  import { CgProfile } from 'react-icons/cg';
  
  function CreateAcount() {
      const { isOpen, onOpen, onClose } = useDisclosure()
      const btnRef = React.useRef()
    
      return (
        <>
          <Button ref={btnRef} colorScheme='white' variant='outline' onClick={onOpen}>
          <CgProfile size={28}/>
        </Button>
          <Drawer
            isOpen={isOpen}
            placement='right'
            onClose={onClose}
            finalFocusRef={btnRef}
          >
            <DrawerOverlay />
            <DrawerContent height="54%  !important">
              <DrawerCloseButton />
              <DrawerHeader onClick={onClose}>Create your account</DrawerHeader>
    
              <DrawerBody>
                <UserForm />
              </DrawerBody>
            </DrawerContent>
          </Drawer>
        </>
      )
    }
  
    export default CreateAcount;